import SuperBillCard from './SuperBillCard';
export default SuperBillCard;
